import { render, staticRenderFns } from "./AppActionDelete.vue?vue&type=template&id=4ae354d4"
import script from "./AppActionDelete.vue?vue&type=script&lang=js"
export * from "./AppActionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports